import React from "react"
import { useWpMenuContext } from "contexts/WpMenuContext"
import "./FooterMenu.scss"

const FooterMenu = () => {
  const { menuItems } = useWpMenuContext()
  const footerMenu = menuItems?.footerMenu

  if (!footerMenu || !Array.isArray(footerMenu)) {
    return null
  }

  return (
    <div className="footer-menu">
      <div className="footer-menu-container">
        {footerMenu.map((section, index) => (
          <div key={index} className="footer-menu-column">
            <h4 className="footer-menu-title">{section.text}</h4>
            {section.children && section.children.length > 0 && (
              <ul className="footer-menu-list">
                {section.children.map((item) => (
                  <li key={item.id} className="footer-menu-item">
                    <a 
                      href={item.url} 
                      className="footer-menu-link"
                      target={item.url.startsWith('http') ? '_blank' : '_self'}
                      rel={item.url.startsWith('http') ? 'noopener noreferrer' : undefined}
                    >
                      {item.text}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default FooterMenu